// EmployeeTerminationApproval.js

import React, { useEffect, useState } from 'react';
import './EmployeeTerminationApproval.css';
import { getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import {
    approveTerminationRequest,
    getPendingTerminations
} from '../../../services/resignationService';
import { format } from 'date-fns';

const EmployeeTerminationApproval = () => {
    const [terminations, setTerminations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedAction, setSelectedAction] = useState({});
    const [remarks, setRemarks] = useState('');
    const [errors, setErrors] = useState({});
    const [rowLoading, setRowLoading] = useState({});

    useEffect(() => {
        fetchPendingTerminations();
    }, []);

    const fetchPendingTerminations = async () => {
        try {
            setLoading(true);
            const data = await getPendingTerminations();
            setTerminations(data);
        } catch (e) {
            setErrors({ fetch: 'Failed to load termination requests' });
        } finally {
            setLoading(false);
        }
    };

    const handleActionChange = (id, action) => {
        setSelectedAction(prev => ({ ...prev, [id]: action }));
        setErrors(prev => ({ ...prev, [id]: null }));
    };


    const validate = (id) => {
        const action = selectedAction[id];

        if (!action) {
            setErrors(prev => ({ ...prev, [id]: 'Select action' }));
            return false;
        }

        if (action === 'reject') {
            setErrors(prev => ({ ...prev, [id]: 'Remarks required for rejection' }));
            return false;
        }

        return true;
    };

    const handleSubmit = async (id) => {
        if (!validate(id)) return;

        const audit = getAuditLog();

        const payload = {
            approved: selectedAction[id] === 'approve',
            pmRemarks: remarks.trim() || "",
            managerId: audit?.employeeId || '',
            auditlog: {
                name: audit?.name || '',
                role: audit?.role || '',
                employeeId: audit?.employeeId || ''
            }
        };

        setRowLoading(prev => ({ ...prev, [id]: true }));

        try {
            await approveTerminationRequest(id, payload);

            setTerminations(prev => prev.filter(t => t.id !== id));
        } catch (e) {
            setErrors(prev => ({
                ...prev,
                [id]: 'Failed to process request'
            }));
        } finally {
            setRowLoading(prev => ({ ...prev, [id]: false }));
        }
    };

    if (loading) {
        return <div className="loader">Loading...</div>;
    }

    return (
        <div className="approval-container">
            <h2 className="title">Employee Termination Approval</h2>

            {errors.fetch && <div className="error-banner">{errors.fetch}</div>}

            <div className='scroll-table'>
                <table className="table">
                    <thead>
                        <tr className='header-approved'>
                            <th>S.No</th>
                            <th>District</th>
                            <th>Name</th>
                            <th>Contact</th>
                            <th>Email</th>
                            <th>Designation</th>
                            <th>Request</th>
                            <th>Termination</th>
                            <th>Reason</th>
                            <th>Remarks</th>
                            <th>Response</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    {terminations.length === 0 ? (
                        <tbody>
                            <tr>
                                <td colSpan={12}>No pending requests </td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {terminations.map((t, i) => (
                                <tr key={t.id}>
                                    <td>{i + 1}</td>
                                    <td>{t.district || '-'}</td>
                                    <td>{t.employeeName}</td>
                                    <td>{t.contact}</td>
                                    <td>{t.email}</td>
                                    <td>{t.designation}</td>
                                    <td>{format(t.requestDate, 'dd-MM-yyyy')}</td>
                                    <td>{format(t.requestedTerminationDate, 'dd-MM-yyyy')}</td>
                                    <td className="reason">{t.reason}</td>

                                    <td>
                                        <input
                                            type="text"
                                            value={remarks}
                                            onChange={(e) => setRemarks(e.target.value)}
                                            placeholder="Enter remarks"
                                        />
                                    </td>

                                    <td>
                                        <div className="actions">
                                            <label>
                                                <input
                                                    type="radio"
                                                    checked={selectedAction[t.id] === 'approve'}
                                                    onChange={() =>
                                                        handleActionChange(t.id, 'approve')
                                                    }
                                                />
                                                Approve
                                            </label>

                                            <label>
                                                <input
                                                    type="radio"
                                                    checked={selectedAction[t.id] === 'reject'}
                                                    onChange={() =>
                                                        handleActionChange(t.id, 'reject')
                                                    }
                                                />
                                                Reject
                                            </label>


                                        </div>
                                    </td>
                                    <td>
                                        <button
                                            onClick={() => handleSubmit(t.id)}
                                            disabled={rowLoading[t.id]}
                                        >
                                            {rowLoading[t.id] ? 'Processing...' : 'Submit'}
                                        </button>

                                        {errors[t.id] && (
                                            <span className="error">{errors[t.id]}</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </table>

            </div>


        </div>
    );
};

export default EmployeeTerminationApproval;